<template>
	<div class="user-profit">
		<search-user-profit
			v-on:onSubmit="onSubmit"
			v-on:resetSearch="resetSearch"
			:search="search"
		>
		</search-user-profit>
		<div class="vue-padding radius">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				:data="userProfitList"
				style="width: 100%"
				max-height="638"
				:border="true"
				show-summary
				:summary-method="getSummaries"
			>
				<el-table-column
					prop="userName"
					:show-overflow-tooltip="true"
					:label="$t('userOrder.userName')"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="num"
					:label="$t('userOrder.allPurchaseNum')"
					width="130"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="sales"
					:label="$t('userOrder.allDuePrice')"
					width="130"
					:align="'center'"
				></el-table-column>
			</el-table>
			<el-pagination
				background
				:picker-options="pickerOptions"
				layout="total,sizes,prev, pager, next,jumper"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				:page-size="page.pageSize"
				@size-change="sizeChange"
				@current-change="currentChange"
			></el-pagination>
		</div>
	</div>
</template>

<script>
import searchUserProfit from "_c/statistics/SearchUserProfit";
export default {
	name: "UserProfit",
	components: {
		searchUserProfit,
	},
	data() {
		return {
			pickerOptions: {
				shortcuts: [
					{
						text: this.$t("TimeControl.week"),
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: this.$t("TimeControl.month"),
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: this.$t("TimeControl.year"),
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit("pick", [start, end]);
						},
					},
				],
			},
			userProfitList: [],
			search: {
				userName: "",
				startDate: "",
				endDate: "",
			},
			page: {
				pageSize: 10,
				pageIndex: 1,
			},
			loading: false,
			order: {
				num: 0,
				sales: 0,
			},
		};
	},
	mounted() {
		this.currentChange();
	},
	methods: {
		// 指定列求和
		getSummaries(param) {
			const { columns, data } = param;
			const sums = [];
			columns.forEach((column, index) => {
				if (index === 0) {
					sums[index] = (
						<span style="font-weight: bold;">
							{this.$t("machineRenewal.total")}
						</span>
					);
					return;
				}
				if (column.property === "num") {
					sums[index] = (
						<span style="font-weight: bold;">{this.order.num}</span>
					);
				} else if (column.property === "sales") {
					sums[index] = (
						<span style="font-weight: bold;">
							{parseFloat(this.order.sales)}
						</span>
					);
				}
			});
			return sums;
		},
		sizeChange(pageSize) {
			this.page.pageSize = pageSize;
			this.currentChange();
		},
		currentChange(pageIndex) {
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			let obj = this.$cloud.objMerge(this.search, this.page);
			this.$api
				.request(this.$url.Statistics.user, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						this.userProfitList = res.data.records;
						this.order = res.data.sum;
						this.page.totalSize = parseInt(res.data.total);
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},
		resetSearch(data) {
			this.search = data;
			this.currentChange();
		},
		onSubmit(data) {
			this.search = data;
			this.currentChange();
		},
	},
};
</script>

<style scoped></style>
